import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconColumns3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"columns-3, layout, third"} maskId="square-filled-radius-0-stroke-1-IconColumns3"><path d="M8.37988 21H3V3H8.37988V21Z" fill="currentColor"/><path d="M14.6201 3V21H9.37988V3H14.6201Z" fill="currentColor"/><path d="M21 21H15.6201V3H21V21Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconColumns3;
